class CartQf {
  constructor() {
    this.cart = window.QF.cart;

    this.endpoints = {
      add: {
        url: 'cart/add.js',
        method: 'post'
      },
      get: {
        url: 'cart.js',
        method: 'get'
      },
      update: {
        url: 'cart/update.js',
        method: 'post'
      },
      clear: {
        url: 'cart/clear.js',
        method: 'post'
      }
    };

    this.selectors = {
      cartDrawerContainer: '#cart-drawer-container'
    };
  }

  dispatchEvent(event_name, includeCart) {
    let contents = null;
    if (includeCart) {
      contents = {
        detail: {
          cart: this.cart,
        },
      };
    }
    window.dispatchEvent(new CustomEvent(event_name, contents));
  }

  async add(data) {
    try {
      const responseData = await this.request('add', data);
      this.mergeWithCurrentCart(responseData);
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("item_added", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async get() {
    try {
      const response = await this.request('get');
      this.cart = response.data;
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async update(data) {
    try {
      const responseData  = await this.request('update', data);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async remove(variant_id) {
    try {
      const updates = {
        updates: {
          [variant_id]: 0,
        }
      };
      const { data: responseData } = await this.request('update', updates);
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("item_removed", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async clear() {
    try {
      const { data: responseData } = await this.request('clear');
      this.cart = responseData;
      this.dispatchEvent("cart_changed", true);
      this.dispatchEvent("cart_cleared", true);
      return this.cart;
    } catch (error) {
      throw error;
    }
  }

  async request(key, data) {
    try {
      const url = window.Shopify.routes.root + this.endpoints[key].url;
      const method = this.endpoints[key].method;
      const headers = {
        'Content-Type': 'application/json'
      };

      const response = await fetch(url, {
        method,
        headers,
        body: JSON.stringify(data)
      });


      if (response.ok) {
        return response.json();
      } else {
        throw await response.json();
      }
    } catch (error) {
      throw error;
    }
  }

  mergeWithCurrentCart(data) {
    if (data.items) {
      data.items.forEach((item) => {
        let index = this.cart.items.findIndex(e => e.id === item.id);
        if (index > -1) {
          this.cart.items[index] = item;
        } else {
          this.cart.items.push(item);
        }
      });
    }
  }

  openSideCart() {
    this.reRenderSideCart(() => {
      let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
      if (sideCartContainer) {
        sideCartContainer.classList.add("open");
        
        document.body.classList.add("fixed");
        this.dispatchEvent("side_cart_opened", false);
      }
    });
  }

  closeSideCart() {
    let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
    if (sideCartContainer) {
      sideCartContainer.classList.remove("open");

      document.body.classList.remove("fixed");
      this.dispatchEvent("side_cart_closed", false);
    }
  }

  async reRenderSideCart(successCallback = null) {
    // UPDATE CART COUNT
    const updateCartCount = () => {
      const cart = document.querySelector('#cart-drawer-container .inner .cart');
      let cart_count = cart.getAttribute('data-items-count');
      const cartCountEl = document.querySelectorAll(".cart-count");
      const cartBtnEl = document.querySelector('.basket.openSideCart');

      if ( cartBtnEl && cartCountEl && cart && cart_count ) {
        
        cartCountEl.forEach(count_el => {
          if ( cart_count == 0 ) {
            count_el.classList.add('empty-cart');
            cartBtnEl.classList.add('empty-cart');
          } else {
            count_el.classList.remove('empty-cart');
            cartBtnEl.classList.remove('empty-cart');
          }
          count_el.innerHTML = cart_count;
        });
      }
    }
    
    try {
      const response = await fetch("/cart?sections=v2-side-cart");
      if (!response.ok) {
        throw new Error("Error: " + response.status);
      }
      const data = await response.json();
      const html = data["v2-side-cart"];

      const side_cart_inner = document.querySelector("#cart-drawer-container .inner");
      if (side_cart_inner && html) {
        side_cart_inner.innerHTML = html;
        
        updateCartCount();
        
        const free_delivery_el = document.querySelector('.free-delivery-status');
        const free_delivery_trigger = free_delivery_el.dataset.freeDelivery;
        const cart_currency = free_delivery_el.dataset.currency;
        const cart_total = document.querySelector('#cart-drawer .sub-total').dataset.subTotal / 100;

        if (!free_delivery_trigger) {
          free_delivery_el.style.display = 'none';
        } else if (cart_total < free_delivery_trigger) {
          const spend_more = (free_delivery_trigger - cart_total).toFixed(2);
          free_delivery_el.innerHTML = `${cart_currency}${spend_more} away from free delivery`;
        } else {
          free_delivery_el.innerHTML = `Free delivery added!`;
        }

        this.cartRenderedEvent(response, html);

        if (successCallback) {
          successCallback();
        }
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  reRenderCart() {
    fetch("/cart?sections=v2-cart")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json(); // Parse the response as JSON
      })
      .then((data) => {
        let html = data["v2-cart"];
        let cart_inner = document.querySelector("#cart-container");
        if (cart_inner && html) {
          cart_inner.innerHTML = html;
          this.cartRenderedEvent(html);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  cartRenderedEvent(response, html) {
    const event = new CustomEvent("cart_rendered", {
      detail: {
        response,
        html,
      },
    });
    window.dispatchEvent(event);
  }
}

// export default new CartQf();
window.CartQf = CartQf;
